import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ReactTable } from './components/ReactTable/ReactTable';
import {ReactAccordion} from './components/ReactTable/ReactAccordion';
import { ReactButton } from './components/ReactTable/ReactButton';
import {ReactInput, ReactInputData} from './components/ReactTable/ReactInput';
import {ReactCheckbox, ReactCheckboxData} from './components/ReactTable/ReactCheckbox';
import {ReactLink, ReactLinkData} from "./components/ReactTable/ReactLink";
import { ReactSearchAsYouType } from './components/ReactTable/ReactSearchAsYouType';
import { ReactMultiSelectSearchAsYouType } from './components/ReactTable/ReactMultiSelectSearchAsYouType';
import {ReactTableShell} from "./components/ReactTable/ReactTableShell";
import {ReactSelect} from "./components/ReactTable/ReactSelect";
import {ReactSelectOption} from "./components/ReactTable/ReactSelectOption";

/**
 * Creates an Orchard ReactTable on the element ID found
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function createReactTable(
    id: string,
    props: any,
    refCallback?: (component: ReactTable) => void
) {
     ReactDOM.render(
        getReactTable(props, refCallback),
        document.getElementById(id) as HTMLElement
    );
}

/**
 * Creates an Orchard ReactTable Object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactTable(
    props: any,
    refCallback?: (component: ReactTable) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        rows: (null != props.rows) ? props.rows : [],
        headers: (null != props.headers) ? props.headers : [],
        headersCSS: (null != props.headersCSS) ? props.headersCSS : '',
        rowsCSS: (null != props.rowsCSS) ? props.rowsCSS : (rowObj : any, rowIndex: number) => {return (rowIndex % 2 == 0) ? 'datatableRow selectableRow even' : 'datatableRow selectableRow odd';},
        rowsStyle: (null != props.rowsStyle) ? props.rowsStyle : (rowObj : any, rowIndex: number) => {return {height: '21px'};},
        highlightSelectedRow: (null != props.highlightSelectedRow) ? props.highlightSelectedRow : 0, // -1 to turn off
        hightlightSelectedRowCSS: (null != props.hightlightSelectedRowCSS) ? props.hightlightSelectedRowCSS : (rowObj : any, rowIndex: number) => {return "copia_tableHighlightColor_b";},
        selectRecordWithRowClick: (null != props.selectRecordWithRowClick) ? props.selectRecordWithRowClick : false,
        tableLabel: (null != props.tableLabel) ? props.tableLabel : '',
        selectColumns: (null != props.selectColumns) ? props.selectColumns : [],
        addSelectColumn: (null != props.addSelectColumn) ? props.addSelectColumn : false,
        selectColumnIndex: (null != props.selectColumnIndex) ? props.selectColumnIndex : 0, // -1 to add to the end
        toolBarDisplayHeader: (null != props.toolBarDisplayHeader) ? props.toolBarDisplayHeader : false, // If toolBarDisplayHeader and toolBarDisplayFooter are false then there is no limit, all rows will display
        toolBarDisplayFooter: (null != props.toolBarDisplayFooter) ? props.toolBarDisplayFooter : false,
        toolBarDisplayCompact: (null != props.toolBarDisplayCompact) ? props.toolBarDisplayCompact : false,
        toolBarDisplayTotalRowsSelected: (null != props.toolBarDisplayTotalRowsSelected) ? props.toolBarDisplayTotalRowsSelected : false,
        toolBarPageNumber: (null != props.toolBarPageNumber) ? props.toolBarPageNumber : 1,
        toolBarNumToDisplay: (null != props.toolBarNumToDisplay) ? props.toolBarNumToDisplay : 10,
        toolBarPrintListOnClick: (null != props.toolBarPrintListOnClick) ? props.toolBarPrintListOnClick : null,
        toolBarExportListOnClick: (null != props.toolBarExportListOnClick) ? props.toolBarExportListOnClick : null,
        toolBarManageColumnsOnClick: (null != props.toolBarManageColumnsOnClick) ? props.toolBarManageColumnsOnClick : null,
        toolBarStyle: (null != props.toolBarStyle) ? props.toolBarStyle : {minWidth: '525px'},
        toolBarCompactStyle: (null != props.toolBarStyle) ? props.toolBarStyle : {minWidth: '215px'},
        enableDragAndDrop: (null != props.enableDragAndDrop) ? props.enableDragAndDrop : false,
        sortColumnIndex: (null != props.sortColumnIndex) ? props.sortColumnIndex : -1, // -1 to add to the end
        onDropEvent: (null != props.onDropEvent) ? props.onDropEvent : null,
        onSortEvent: (null != props.onSortEvent) ? props.onSortEvent : null,
        divContainerCSS: (null != props.divContainerCSS) ? props.divContainerCSS : '',
        style: (null != props.style) ? props.style : {},
        divTableContainerCSS: (null != props.divTableContainerCSS) ? props.divTableContainerCSS : 'object-selection-table-parent overFlowAuto',
        tableStyle: (null != props.tableStyle) ? props.tableStyle : {},
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        toolBarRefreshID: (null != props.toolBarRefreshID) ? props.toolBarRefreshID : "",
        onToolBarRefresh: (null != props.onToolBarRefresh) ? props.onToolBarRefresh : null,
        disableID: (null != props.disableID) ? props.disableID : "",
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        disabled: (null != props.disabled) ? props.disabled : false,
        disableHeaderScrolling: (null != props.disableHeaderScrolling) ? props.disableHeaderScrolling : false,
        onSelectCellClick: (null != props.onSelectCellClick) ? props.onSelectCellClick : null,
        selectHeaderClick: (null != props.selectHeaderClick) ? props.selectHeaderClick : null,
        clearSelectionClick: (null != props.clearSelectionClick) ? props.clearSelectionClick : null,
        addDeleteColumn: (null != props.addDeleteColumn) ? props.addDeleteColumn : false,
        deleteButtonTabIndex: (null != props.deleteButtonTabIndex) ? props.deleteButtonTabIndex : null,
        deleteColumnIndex: (null != props.deleteColumnIndex) ? props.deleteColumnIndex : 0, // -1 to add to the end
        onDelete: (null != props.onDelete) ? props.onDelete : null,
        lockedRows: (null != props.lockedRows) ? props.lockedRows : [],
        noRecordsSelectedText: (null != props.noRecordsSelectedText) ? props.noRecordsSelectedText : "No records selected",
        addCustomFilterOptions: (null != props.addCustomFilterOptions) ? props.addCustomFilterOptions : null,
        customFilterCSS: (null != props.customFilterCSS) ? props.customFilterCSS : "",
        customFilter: (null != props.customFilter) ? props.customFilter : null,
        addCustomToolBarOptions: (null != props.addCustomToolBarOptions) ? props.addCustomToolBarOptions : null,
        isSelectedKey: (null != props.isSelectedKey) ? props.isSelectedKey : "isSelected",
        customSortIndexKey: (null != props.customSortIndexKey) ? props.customSortIndexKey : "customSortIndex",
        onRowDoubleClick: (null != props.onRowDoubleClick) ? props.onRowDoubleClick : null,
        clearButtonTabIndex: (null != props.clearButtonTabIndex) ? props.clearButtonTabIndex : null,
    };

    return <ReactTableShell {...setProps as any} ref={refCallback} />;
}


/**
 * Creates an Orchard ReactTable Object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactTableLocal(
    props: any,
    refCallback?: (component: ReactTable) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        rows: (null != props.rows) ? props.rows : [],
        filteredRows: (null != props.filteredRows) ? props.filteredRows : [],
        headers: (null != props.headers) ? props.headers : [],
        headersCSS: (null != props.headersCSS) ? props.headersCSS : '',
        rowsCSS: (null != props.rowsCSS) ? props.rowsCSS : null,
        rowsStyle: (null != props.rowsStyle) ? props.rowsStyle : (rowObj : any, rowIndex: number) => {return {height: '21px'};},
        highlightSelectedRow: (null != props.highlightSelectedRow) ? props.highlightSelectedRow : 0, // -1 to turn off
        hightlightSelectedRowCSS: (null != props.hightlightSelectedRowCSS) ? props.hightlightSelectedRowCSS : (rowObj : any, rowIndex: number) => {return "copia_tableHighlightColor_b";},
        tableLabel: (null != props.tableLabel) ? props.tableLabel : '',
        showTable: (null != props.showTable) ? props.showTable : true,
        isSearchAsYouType: (null != props.isSearchAsYouType) ? props.isSearchAsYouType : false,
        hideSAYTOnSelect: (null != props.hideSAYTOnSelect) ? props.hideSAYTOnSelect : true,
        selectColumns: (null != props.selectColumns) ? props.selectColumns : [],
        onSelectCellClick: (null != props.onSelectCellClick) ? props.onSelectCellClick : null,
        addSelectColumn: (null != props.addSelectColumn) ? props.addSelectColumn : false,
        selectColumnIndex: (null != props.selectColumnIndex) ? props.selectColumnIndex : 0, // -1 to add to the end
        toolBarDisplayHeader: (null != props.toolBarDisplayHeader) ? props.toolBarDisplayHeader : false, // If toolBarDisplayHeader and toolBarDisplayFooter are false then there is no limit, all rows will display
        toolBarDisplayFooter: (null != props.toolBarDisplayFooter) ? props.toolBarDisplayFooter : false,
        toolBarDisplayCompact: (null != props.toolBarDisplayCompact) ? props.toolBarDisplayCompact : false,
        toolBarDisplayTotalRowsSelected: (null != props.toolBarDisplayTotalRowsSelected) ? props.toolBarDisplayTotalRowsSelected : false,
        toolBarPageNumber: (null != props.toolBarPageNumber) ? props.toolBarPageNumber : 1,
        toolBarNumToDisplay: (null != props.toolBarNumToDisplay) ? props.toolBarNumToDisplay : 10,
        toolBarPrintListOnClick: (null != props.toolBarPrintListOnClick) ? props.toolBarPrintListOnClick : null,
        toolBarExportListOnClick: (null != props.toolBarExportListOnClick) ? props.toolBarExportListOnClick : null,
        toolBarManageColumnsOnClick: (null != props.toolBarManageColumnsOnClick) ? props.toolBarManageColumnsOnClick : null,
        toolBarStyle: (null != props.toolBarStyle) ? props.toolBarStyle : {minWidth: '525px'},
        toolBarCompactStyle: (null != props.toolBarStyle) ? props.toolBarStyle : {minWidth: '215px'},
        enableDragAndDrop: (null != props.enableDragAndDrop) ? props.enableDragAndDrop : false,
        sortColumnIndex: (null != props.sortColumnIndex) ? props.sortColumnIndex : -1, // -1 to add to the end
        onDropEvent: (null != props.onDropEvent) ? props.onDropEvent : null,
        onDuringDragEvent: (null != props.onDuringDragEvent) ? props.onDuringDragEvent : null,
        onSortEvent: (null != props.onSortEvent) ? props.onSortEvent : null,
        divContainerCSS: (null != props.divContainerCSS) ? props.divContainerCSS : '',
        style: (null != props.style) ? props.style : {},
        toolBarUpdate: (null != props.toolBarUpdate) ? props.toolBarUpdate : null,
        sortUpdate: (null != props.sortUpdate) ? props.sortUpdate : null,
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        toolBarRefreshID: (null != props.toolBarRefreshID) ? props.toolBarRefreshID : "",
        onToolBarRefresh: (null != props.onToolBarRefresh) ? props.onToolBarRefresh : null,
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        disabled: (null != props.disabled) ? props.disabled : false,
        disableHeaderScrolling: (null != props.disableHeaderScrolling) ? props.disableHeaderScrolling : false,
        selectHeaderClick: (null != props.selectHeaderClick) ? props.selectHeaderClick : null,
        clearSelectionClick: (null != props.clearSelectionClick) ? props.clearSelectionClick : null,
        addDeleteColumn: (null != props.addDeleteColumn) ? props.addDeleteColumn : false,
        deleteColumnIndex: (null != props.deleteColumnIndex) ? props.deleteColumnIndex : 0, // -1 to add to the end
        onDelete: (null != props.onDelete) ? props.onDelete : null,
        lockedRows: (null != props.lockedRows) ? props.lockedRows : [],
        toolBarNumToDisplayTyped: (null != props.toolBarNumToDisplay) ? props.toolBarNumToDisplay : 10,
        toolBarPageNumberTyped: (null != props.toolBarPageNumber) ? props.toolBarPageNumber : 1,
        noRecordsSelectedText: (null != props.noRecordsSelectedText) ? props.noRecordsSelectedText : "No records selected",
        addCustomFilterOptions: (null != props.addCustomFilterOptions) ? props.addCustomFilterOptions : null,
        customFilterCSS: (null != props.customFilterCSS) ? props.customFilterCSS : "",
        addCustomToolBarOptions: (null != props.addCustomToolBarOptions) ? props.addCustomToolBarOptions : null,
        deleteButtonTabIndex: (null != props.deleteButtonTabIndex) ? props.deleteButtonTabIndex : null,
        selectRecordWithRowClick: (null != props.selectRecordWithRowClick) ? props.selectRecordWithRowClick : false,
        isSelectedKey: (null != props.isSelectedKey) ? props.isSelectedKey : "isSelected",
        onRowDoubleClick: (null != props.onRowDoubleClick) ? props.onRowDoubleClick : null,
        getTotalSelected: (null != props.getTotalSelected) ? props.getTotalSelected : null,
        clearButtonTabIndex: (null != props.clearButtonTabIndex) ? props.clearButtonTabIndex : null,
        onSAYTTableDisplayEvent: (null != props.onSAYTTableDisplayEvent) ? props.onSAYTTableDisplayEvent : null,
        divSAYTWindowCSS: (null != props.divSAYTWindowCSS) ? props.divSAYTWindowCSS : null,
    };

    return <ReactTable {...setProps as any} ref={refCallback} />;
}

/**
 * Creates an Orchard ReactAccordion on the element ID found
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function createReactAccordion(
    id: string,
    props: any,
    refCallback?: (component: ReactAccordion) => void
) {
    ReactDOM.render(
        getReactAccordion(props, refCallback),
        document.getElementById(id) as HTMLElement
    );
}

/**
 * Gets an Orchard ReactAccordion Object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactAccordion(
    props: any,
    refCallback?: (component: ReactAccordion) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : "",
        text: (null != props.text) ? props.text : '',
        content: (null != props.content) ? props.content : {},
        style: (null != props.style) ? props.style : {margin: "0px"},
        css: (null != props.css) ? props.css : 'sectionHeader ui-accordion-header reactTableCell react-accordion-header react-rounded-bottom react-rounded-top',
        expandedCSS: (null != props.expandedCSS) ? props.expandedCSS : 'sectionHeader ui-accordion-header reactTableCell react-accordion-header react-rounded-top',
        expandedStyle: (null != props.expandedStyle) ? props.expandedStyle : {margin: "0px"},
        contentStyle: (null != props.contentStyle) ? props.contentStyle : {},
        contentCSS: (null != props.contentCSS) ? props.contentCSS : 'flex-container flex-column ui-accordion-content react-accordion-content react-rounded-bottom ui-accordion-content-active',
        dataKey: (null != props.dataKey) ? props.dataKey : "isExpanded",
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        row: (null != props.row) ? props.row : {},
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        onClick: (null != props.onClick) ? props.onClick : (rowObj : any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => {
            const dataKey = (null != props.dataKey) ? props.dataKey : "isExpanded";
            const isExpanded = null != rowObj[dataKey] && rowObj[dataKey];
            return !isExpanded;
        },
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        title: (null != props.title) ? props.title : "",
        expandedID: (null != props.expandedID) ? props.expandedID : "",
        stopPropagationOnClick: (null != props.stopPropagationOnClick) ? props.stopPropagationOnClick : null,
    };

    return <ReactAccordion {...setProps as any} ref={refCallback} />;
}

/**
 * Gets an Orchard ReactButton object
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactButton(
    props: any,
    refCallback?: (component: ReactButton) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : "",
        text: (null != props.text) ? props.text : "",
        title: (null != props.title) ? props.title : "",
        css: (null != props.css) ? props.css : "",
        onClick: (null != props.onClick) ? props.onClick : null,
        row: (null != props.row) ? props.row : null,
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        style: (null != props.style) ? props.style : {},
        disabled: (null != props.disabled) ? props.disabled : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        stopPropagationOnClick: (null != props.stopPropagationOnClick) ? props.stopPropagationOnClick : null,
    };

    return <ReactButton {...setProps as any} ref={refCallback} />;
}

/**
 * Creates an Orchard ReactInput object
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactInput(
    props: any,
    refCallback?: (component: ReactInput) => void
) {

    const setProps = {
        id: (null != props.id) ? props.id : "",
        row: (null != props.row) ? props.row : null,
        type: (null != props.type) ? props.type : "text",
        onChange: (null != props.onChange) ? props.onChange : null,
        onKeyDown: (null != props.onKeyDown) ? props.onKeyDown : null,
        onKeyUp: (null != props.onKeyUp) ? props.onKeyUp : null,
        onFocus: (null != props.onFocus) ? props.onFocus : null,
        onBlur: (null != props.onBlur) ? props.onBlur : null,
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        style: (null != props.style) ? props.style : {},
        css: (null != props.css) ? props.css : '',
        disabled: (null != props.disabled) ? props.disabled : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        dataKey: (null != props.dataKey) ? props.dataKey : "dataKey",
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        title: (null != props.title) ? props.title : "",
    } as ReactInputData;

    return <ReactInput {...setProps as any} ref={refCallback} />;
}

/**
 * Gets an Orchard ReactCheckbox object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactCheckbox(
    props: any
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        onClick: (null != props.onClick) ? props.onClick : null,
        row: (null != props.row) ? props.row : {},
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        disabled: (null != props.disabled) ? props.disabled : false,
        label: (null != props.label) ? props.label : '',
        css: (null != props.css) ? props.css : 'align-obj-center',
        style: (null != props.style) ? props.style : {},
        labelStyle: (null != props.labelStyle) ? props.labelStyle : {paddingBottom: '3px'},
        disableID: (null != props.disableID) ? props.disableID : "",
        dataKey: (null != props.dataKey) ? props.dataKey : "dataKey",
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        title: (null != props.title) ? props.title : "",
        stopPropagationOnClick: (null != props.stopPropagationOnClick) ? props.stopPropagationOnClick : null,
    } as ReactCheckboxData;

    return <ReactCheckbox {...setProps as any} />;
}

/**
 * Gets an Orchard ReactLink object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactLink(
    props: any
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        href: (null != props.href) ? props.href : '#',
        text: (null != props.text) ? props.text : '',
        style: (null != props.style) ? props.style : {},
        css: (null != props.css) ? props.css : '',
        row: (null != props.row) ? props.row : null,
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        onClick: (null != props.onClick) ? props.onClick : null,
        disabled: (null != props.disabled) ? props.disabled : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        title: (null != props.title) ? props.title : "",
        stopPropagationOnClick: (null != props.stopPropagationOnClick) ? props.stopPropagationOnClick : null,
    } as ReactLinkData;

    return <ReactLink {...setProps as any} />;
}

/**
 * Gets an Orchard ReactSelect object
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactSelect(
    props: any,
    refCallback?: (component: ReactSelect) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : "",
        customOption: (null != props.customOption) ? props.customOption : null,
        css: (null != props.css) ? props.css : "",
        onChange: (null != props.onChange) ? props.onChange : null,
        row: (null != props.row) ? props.row : null,
        rowIndex: (null != props.rowIndex) ? props.rowIndex : -1,
        dataKey: (null != props.dataKey) ? props.dataKey : "dataKey",
        style: (null != props.style) ? props.style : {},
        disabled: (null != props.disabled) ? props.disabled : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        title: (null != props.title) ? props.title : "",
    };

    return <ReactSelect {...setProps as any} ref={refCallback} />;
}

/**
 * Gets an Orchard ReactSelect object
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactSelectOption(
    props: any,
    refCallback?: (component: ReactSelectOption) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : "",
        css: (null != props.css) ? props.css : "",
        style: (null != props.style) ? props.style : {},
        disabled: (null != props.disabled) ? props.disabled : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        value: (null != props.value) ? props.value : "",
        text: (null != props.text) ? props.text : "",
        title: (null != props.title) ? props.title : "",
        row: (null != props.row) ? props.row : null,
        dataKey: (null != props.dataKey) ? props.dataKey : "dataKey",
    };

    return <ReactSelectOption {...setProps as any} ref={refCallback} />;
}

/**
 * Creates an Orchard React SAYT on the element ID found
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function createReactSearchAsYouType(
    id: string,
    props: any,
    refCallback?: (component: ReactSearchAsYouType) => void
) {
    ReactDOM.render(
        getReactSearchAsYouType(props, refCallback),
        document.getElementById(id) as HTMLElement
    );
}

/**
 * Creates an Orchard React SAYT Object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactSearchAsYouType(
    props: any,
    refCallback?: (component: ReactSearchAsYouType) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        label: (null != props.label) ? props.label : "",
        labelStyle: (null != props.labelStyle) ? props.labelStyle : {},
        labelCSS: (null != props.labelCSS) ? props.labelCSS : null,
        textStyle: (null != props.textStyle) ? props.textStyle : {},
        tableStyle: (null != props.tableStyle) ? props.tableStyle : {},
        headers: (null != props.headers) ? props.headers : [],
        headersCSS: (null != props.headersCSS) ? props.headersCSS : '',
        rowsCSS: (null != props.rowsCSS) ? props.rowsCSS : (rowObj : any, rowIndex: number) => {return (rowIndex % 2 == 0) ? 'datatableRow selectableRow even' : 'datatableRow selectableRow odd';},
        rowsStyle: (null != props.rowsStyle) ? props.rowsStyle : (rowObj : any, rowIndex: number) => {return {height: '21px'};},
        rows: (null != props.rows) ? props.rows : [],
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        divTableContainerCSS: (null != props.divTableContainerCSS) ? props.divTableContainerCSS : 'overFlowAuto',
        highlightSelectedRow: (null != props.highlightSelectedRow) ? props.highlightSelectedRow : 0, // -1 to turn off
        hightlightSelectedRowCSS: (null != props.hightlightSelectedRowCSS) ? props.hightlightSelectedRowCSS : (rowObj : any, rowIndex: number) => {return "copia_tableHighlightColor_b";},
        toolBarDisplayHeader: (null != props.toolBarDisplayHeader) ? props.toolBarDisplayHeader : false,
        toolBarDisplayFooter: (null != props.toolBarDisplayFooter) ? props.toolBarDisplayFooter : true,
        toolBarNumToDisplay: (null != props.toolBarNumToDisplay) ? props.toolBarNumToDisplay : 10,
        selectColumns: (null != props.selectColumns) ? props.selectColumns : [0],
        saytSelectDisplayColumn: (null != props.saytSelectDisplayColumn) ? props.saytSelectDisplayColumn : 0,
        onSAYTClickEvent: (null != props.onSAYTClickEvent) ? props.onSAYTClickEvent : null,
        hideSearchOnSelect: (null != props.hideSearchOnSelect) ? props.hideSearchOnSelect : true,
        showClearButton: (null != props.showClearButton) ? props.showClearButton : true,
        clearButtonTabIndex: (null != props.clearButtonTabIndex) ? props.clearButtonTabIndex : null,
        showSearchButton: (null != props.showSearchButton) ? props.showSearchButton : true,
        searchButtonTabIndex: (null != props.searchButtonTabIndex) ? props.searchButtonTabIndex : null,
        disabled: (null != props.disabled) ? props.disabled : false,
        disableHeaderScrolling: (null != props.disableHeaderScrolling) ? props.disableHeaderScrolling : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        toolBarRefreshID: (null != props.toolBarRefreshID) ? props.toolBarRefreshID : "",
        onToolBarRefresh: (null != props.onToolBarRefresh) ? props.onToolBarRefresh : null,
        noRecordsSelectedText: (null != props.noRecordsSelectedText) ? props.noRecordsSelectedText : "No records selected",
        addCustomFilterOptions: (null != props.addCustomFilterOptions) ? props.addCustomFilterOptions : null,
        customFilterCSS: (null != props.customFilterCSS) ? props.customFilterCSS : "reactTableFilter",
        customFilter: (null != props.customFilter) ? props.customFilter : null,
        onFocusOut: (null != props.onFocusOut) ? props.onFocusOut : null,
        selectRecordWithRowClick: (null != props.selectRecordWithRowClick) ? props.selectRecordWithRowClick : false,
        isSelectedKey: (null != props.isSelectedKey) ? props.isSelectedKey : "isSelected",
        onSortEvent: (null != props.onSortEvent) ? props.onSortEvent : null,
        showSearchButtonAfterClearButton: (null != props.showSearchButtonAfterClearButton) ? props.showSearchButtonAfterClearButton : true,
        onSAYTTableDisplayEvent: (null != props.onSAYTTableDisplayEvent) ? props.onSAYTTableDisplayEvent : null,
        divSAYTWindowCSS: (null != props.divSAYTWindowCSS) ? props.divSAYTWindowCSS : null,
        onBeforeSAYTTableDisplayEvent: (null != props.onBeforeSAYTTableDisplayEvent) ? props.onBeforeSAYTTableDisplayEvent : null,
        onClearButtonClick: (null != props.onClearButtonClick) ? props.onClearButtonClick : null,
        allowFreeTextInput: (null != props.allowFreeTextInput) ? props.allowFreeTextInput : false,
        addCustomFreeTextRow: (null != props.addCustomFreeTextRow) ? props.addCustomFreeTextRow : null,
        isFreeTextKey: (null != props.isFreeTextKey) ? props.isFreeTextKey : "isFreeText",
    };

    return <ReactSearchAsYouType {...setProps as any} ref={refCallback} />;
}

/**
 * Creates an Orchard Multiselect React SAYT on the element ID found
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function createReactMultiSelectSearchAsYouType(
    id: string,
    props: any,
    refCallback?: (component: ReactMultiSelectSearchAsYouType) => void
) {
    ReactDOM.render(
        getReactMultiSelectSearchAsYouType(props, refCallback),
        document.getElementById(id) as HTMLElement
    );
}


/**
 * Creates an Orchard Multiselect React SAYT Object
 * @param id The id of the div element to build the data table in
 * @param options The options object
 * @param refCallback A callback executed once rendering is complete, providing a reference to the ReactTable component
 */
export function getReactMultiSelectSearchAsYouType(
    props: any,
    refCallback?: (component: ReactMultiSelectSearchAsYouType) => void
) {
    const setProps = {
        id: (null != props.id) ? props.id : '',
        label: (null != props.label) ? props.label : "",
        tableLabel: (null != props.tableLabel) ? props.tableLabel : '',
        style: (null != props.style) ? props.style : {},
        labelStyle: (null != props.labelStyle) ? props.labelStyle : {},
        labelCSS: (null != props.labelCSS) ? props.labelCSS : null,
        textStyle: (null != props.textStyle) ? props.textStyle : {},
        saytTableStyle: (null != props.saytTableStyle) ? props.saytTableStyle : {},
        tableStyle: (null != props.tableStyle) ? props.tableStyle : {},
        headers: (null != props.headers) ? props.headers : [],
        headersCSS: (null != props.headersCSS) ? props.headersCSS : '',
        rowsCSS: (null != props.rowsCSS) ? props.rowsCSS : (rowObj : any, rowIndex: number) => {return (rowIndex % 2 == 0) ? 'datatableRow selectableRow even' : 'datatableRow selectableRow odd';},
        rowsStyle: (null != props.rowsStyle) ? props.rowsStyle : (rowObj : any, rowIndex: number) => {return {height: '28px'};},
        selectionRowsCSS: (null != props.selectionRowsCSS) ? props.selectionRowsCSS : (rowObj : any, rowIndex: number) => {return (rowIndex % 2 == 0) ? 'datatableRow selectableRow even' : 'datatableRow selectableRow odd';},
        selectionRowsStyle: (null != props.selectionRowsStyle) ? props.selectionRowsStyle : (rowObj : any, rowIndex: number) => {return {height: '28px'};},
        rows: (null != props.rows) ? props.rows : [],
        tabIndex: (null != props.tabIndex) ? props.tabIndex : null,
        selectionHeaders: (null != props.selectionHeaders) ? props.selectionHeaders : ((props.headers) ? props.headers : []),
        selectionHeadersCSS: (null != props.selectionHeadersCSS) ? props.selectionHeadersCSS : '',
        divContainerCSS: (null != props.divContainerCSS) ? props.divContainerCSS : "mutliSelectSAYTBorder",
        divTableContainerCSS: (null != props.divTableContainerCSS) ? props.divTableContainerCSS : 'object-selection-table-parent overFlowAuto',
        divSAYTTableContainerCSS: (null != props.divSAYTTableContainerCSS) ? props.divSAYTTableContainerCSS : 'overFlowAuto',
        highlightSelectedRow: (null != props.highlightSelectedRow) ? props.highlightSelectedRow : 0, // -1 to turn off
        hightlightSelectedRowCSS: (null != props.hightlightSelectedRowCSS) ? props.hightlightSelectedRowCSS : (rowObj : any, rowIndex: number) => {return "copia_tableHighlightColor_b";},
        toolBarDisplayHeader: (null != props.toolBarDisplayHeader) ? props.toolBarDisplayHeader : false,
        toolBarDisplayFooter: (null != props.toolBarDisplayFooter) ? props.toolBarDisplayFooter : true,
        toolBarNumToDisplay: (null != props.toolBarNumToDisplay) ? props.toolBarNumToDisplay : 10,
        selectColumns: (null != props.selectColumns) ? props.selectColumns : [0],
        onSAYTClickEvent: (null != props.onSAYTClickEvent) ? props.onSAYTClickEvent : null,
        hideSearchOnSelect: (null != props.hideSearchOnSelect) ? props.hideSearchOnSelect : false,
        showSearchButton: (null != props.showSearchButton) ? props.showSearchButton : true,
        searchButtonTabIndex: (null != props.searchButtonTabIndex) ? props.searchButtonTabIndex : null,
        disabled: (null != props.disabled) ? props.disabled : false,
        disableHeaderScrolling: (null != props.disableHeaderScrolling) ? props.disableHeaderScrolling : false,
        disableID: (null != props.disableID) ? props.disableID : "",
        refreshID: (null != props.refreshID) ? props.refreshID : "",
        refreshSAYTTableID: (null != props.refreshSAYTTableID) ? props.refreshSAYTTableID : "",
        onRefresh: (null != props.onRefresh) ? props.onRefresh : null,
        toolBarRefreshID: (null != props.toolBarRefreshID) ? props.toolBarRefreshID : "",
        onToolBarRefresh: (null != props.onToolBarRefresh) ? props.onToolBarRefresh : null,
        noRecordsSelectedText: (null != props.noRecordsSelectedText) ? props.noRecordsSelectedText : "No records selected",
        addCustomFilterOptions: (null != props.addCustomFilterOptions) ? props.addCustomFilterOptions : null,
        customFilterCSS: (null != props.customFilterCSS) ? props.customFilterCSS : "reactTableFilter",
        customFilter: (null != props.customFilter) ? props.customFilter : null,
        onFocusOut: (null != props.onFocusOut) ? props.onFocusOut : null,
        selectRecordWithRowClick: (null != props.selectRecordWithRowClick) ? props.selectRecordWithRowClick : false,
        isSelectedKey: (null != props.isSelectedKey) ? props.isSelectedKey : "isSelected",
        onSortEvent: (null != props.onSortEvent) ? props.onSortEvent : null,
        selectHeaderClick: (null != props.selectHeaderClick) ? props.selectHeaderClick : null,
        onSAYTTableDisplayEvent: (null != props.onSAYTTableDisplayEvent) ? props.onSAYTTableDisplayEvent : null,
        divSAYTWindowCSS: (null != props.divSAYTWindowCSS) ? props.divSAYTWindowCSS : null,
        onBeforeSAYTTableDisplayEvent: (null != props.onBeforeSAYTTableDisplayEvent) ? props.onBeforeSAYTTableDisplayEvent : null,
    };

    return <ReactMultiSelectSearchAsYouType {...setProps as any} ref={refCallback} />
}

export {
    ReactTable,
    ReactAccordion,
    ReactButton,
    ReactInput,
    ReactCheckbox,
    ReactLink,
    ReactSelect,
    ReactSelectOption,
    ReactSearchAsYouType,
    ReactMultiSelectSearchAsYouType
};
